<template>
  <div v-lazy-container="{ selector: 'img' }">
    <img
      v-show="img"
      :data-src="img"
      :data-loading="defaultImg"
      class="avatar"
    >
    <div
      v-show="!img"
      class="default-avatar"
    >
      <img :data-src="defaultImg">
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserAvatar',
  props: {
    img: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    defaultImg: require('../assets/svg/default-user-avatar.svg')
  })
}
</script>

<style lang="scss" scoped>
.avatar {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  object-fit: cover;
}
.default-avatar {
  background-color: #f0f0f0;
  border-radius: 50%;
  width: 45px;
  height: 45px;
  padding-top: 8px;
  text-align: center;

  img {
    width: 25px;
    height: 25px;
    text-align: center;
  }
}
/* Less than tablet */
@media only screen and (max-width: 1087px) {
  .avatar {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    margin-top: -9px;
  }
  .default-avatar {
    background-color: #f0f0f0;
    border-radius: 50%;
    width: 35px;
    height: 35px;
    padding-top: 6px;
    text-align: center;
    margin-top: -10px;

    img {
      width: 20px;
      height: 20px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UserAvatar.vue